import { EmployeePermission } from './api/permissions';
import { PlaceType, RoomType } from './types';

export const labelsByRoomType: Record<RoomType, string> = {
  [RoomType.Meeting]: 'Переговорка',
  [RoomType.Focus]: 'Фокус-комната',
  [RoomType.Phone]: 'Телефонная кабинка',
};

export const placeTypeByPermission: Record<PlaceType, EmployeePermission> = {
  [PlaceType.Desk]: EmployeePermission.BookDesks,
  [PlaceType.Room]: EmployeePermission.BookRooms,
  [PlaceType.Parking]: EmployeePermission.BookParkingPlaces,
};

export const fullscreenIsSupported: boolean = !!document.body.requestFullscreen;
